import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/router/index.tsx'
import { UserProvider } from '@/@diffrag/providers/user.provider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from '@/components/ui/toaster.tsx'
import { Toaster as Sooner } from '@/components/ui/sonner.tsx'
import SideBarProvider from '@/@diffrag/sidebar/SideBarProvider'
import * as Sentry from '@sentry/react'

// Sentry 초기화
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // 프로덕션에서는 낮은 값으로 조정
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SideBarProvider>
        <UserProvider>
          <RouterProvider router={router} />
          <Toaster />
          <Sooner />
        </UserProvider>
      </SideBarProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
